import { TextArea, styled } from '@withjoy/joykit';

export const StyledTextArea = styled(TextArea)`
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.mono14};
  transition:
    border-color 500ms cubic-bezier(0.23, 1, 0.32, 1) 0s,
    color 500ms cubic-bezier(0.23, 1, 0.32, 1) 0s,
    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1) 0s,
    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1) 0s;
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-color: ${props => props.theme.colors.inputBorder};
  font-size: 0.9375rem;
  height: 3rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
`;
